import Vue from 'vue';
import _ from '_';
// import tpl from './tpl.html';
// import './style.css';

var defaults = {
	showClose: false,
	title: '',
	content: '',
	theme: '',
	okText: '确定'
	, okStyle: ''
};

var CURRENT = null;
var tpl = `<div class="mask center" :class="theme" style="z-index: 9;">
<style>
.newSkin .popup{
    /*padding-bottom: 88px;*/
    min-height: auto;
	background: transparent;
}
.newSkin .alert_content{
	border-radius: 0 0 4px 4px;
    margin: 0;
    padding: 0.6667rem;
    background: #fff;
}
.newSkin .alert_ok{
	left: 0;
    right: 0;
    height: 22px;
    width: 22px;
    border: 0;
    border-radius: 50%;
    margin: auto;
    padding: 0;
    background: #16bb80;
    color: #fff;
    font-size: 16px;
    line-height: 1;
}
</style>
	<div class="popup popup-alert border-radius" style="position: relative;">
		<button v-if="showClose" type="button" class="icon icon-close pos-a marginb10 popup_close alert_close" @click="cancel()"></button>
		<i v-show="iconName" class="icon-{{iconName}}"></i>
		<div class="margint50 marginb20 paddingh40 fs-18 popup_title alert_title" v-show="title" v-html="title"></div>
		<div class="marginb50 paddingh40 fs-15 popup_content alert_content" v-html="content" v-bind:class="{'margint50':!title}"></div>
		<button class="btn pos-a bottom-n0 popup_ok alert_ok" type="button" v-if="theme!=='newSkin'" :style="okStyle" v-html="okText" @click="cancel()"></button>
		<button class="btn pos-a bottom-n0 popup_ok alert_ok" type="button" v-if="theme==='newSkin'" @click="cancel()">
			<i class="icon icon-close"></i>
		</button>
	</div>
	<!--<div class="alert_ok" v-if="theme==='newSkin'" @click="cancel()">-->
		<!--<i class="icon icon-close"></i>-->
	<!--</div>-->
</div>`;

function Alert(options){
	if( typeof options === 'string' ){
		options = {
			content: options
		};
	}

	options = _.defaults(options, defaults);

	document.body.classList.add('overflow-h');

	if( CURRENT ){
		CURRENT.$destroy(true);
	}

	CURRENT = new Vue({
		el: document.body.appendChild(document.createElement('div')),
		template: tpl,
		data: options,
		methods: {
			cancel: function(){
				this.$destroy(true);
				document.body.classList.remove('overflow-h');
				options.okFn && options.okFn(this.$el);
			}
		}
		, destroy: function(){
			options.okFn && options.okFn(this.$el);
		}
	});

	return CURRENT;
}

export default Alert;